import axios from 'axios';
import { HashResponse } from '../../../interfaces/interfaceServices';
import { redirectTo } from '../navigationService';

const deleteToken = () => {
  localStorage.removeItem('accessToken');
  redirectTo('/');
};

export const generateHash = async (
  rut: string,
  dv: string,
  telefono: string
): Promise<HashResponse | undefined> => {
  const apiUrl = `${process.env.REACT_APP_API_URL}/identity-validation-bff/v1.0.0/identity-validation/token`;
  const token = localStorage.getItem('accessToken');

  if (!token || token.trim() === '') {
    console.error('Token no válido. Por favor, inicia sesión nuevamente.');
    throw new Error('Token de acceso inválido');
  }

  try {
    const response = await axios.post(
      apiUrl,
      { rut, dv, telefono },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'x-business': 'GASCO',
          'x-commerce': 'GASCO',
          'x-country': 'CL',
          'x-system': 'IdentityValidation',
          'x-user': 'GASCO_USER',
        },
      }
    );

    return response.data;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;
      const data = error.response?.data;

      console.error('Error al generar hash:', { status, data });

      const errorMessage = (error.response?.data || '')
      .toString()
      .trim()
      .toLowerCase();
    if (errorMessage === 'invalid token') {
      deleteToken();
    }
    } else {
      console.error('Error inesperado:', error);
    }
    throw error;
  }
};
